import { ITransientStateResponse } from "../../interfaces/session/user-session-v3";
import { IAuthRefeshSuccessAction } from "../interfaces/auth.interface";

export function refreshSucess(data: ITransientStateResponse): IAuthRefeshSuccessAction {
  return {
    type: "REFRESH_SUCCESS",
    data,
  };
}
